// src/api/cancel_bookings.ts
import api from "./client";

export async function cancelBookingByToken(token: string) {
  try {
    const res = await api.get("/cancelBookingByToken", {
      params: { token },
    });
    return res.data;
  } catch (error) {
    console.error("❌ Failed to cancel booking:", error);
    throw error;
  }
}
